import React, { useMemo } from 'react';
import cn from 'classnames';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { RoutingStore } from '../../stores/RoutingStore';
import { ConfigStore } from '../../stores/ConfigStore';
import { CategoriesStore } from '../../stores/CategoriesStore';
import { getBreadcrumbsPath } from '../../../utils/getBreadcrumbs';
import { SubTitle } from './SubTitle/SubTitle';
import { SubText } from './SubText/SubText';
import { SubHeaderBreadcrumbs } from './SubHeaderBreadcrumbs/SubHeaderBreadcrumbs';
import { SubCategories } from './SubCategories/SubCategories';
import { subHeaderDataHooks } from './SubHeader.dataHooks';
import s from './SubHeader.scss';

export interface SubHeaderProps {
  configStore: ConfigStore;
  routingStore: RoutingStore;
  templatesStore: TemplatesStore;
  categoriesStore: CategoriesStore;
  dataHook?: string;
}

const SubHeaderCmp: React.FC<SubHeaderProps> = (props) => {
  const { dataHook, configStore, routingStore, templatesStore } = props;
  const { activeSubCategory, activeCategory } = templatesStore;
  const { activeMicroCategorySlug } = routingStore;
  const isEnabledMicroCategories = configStore.config.currentLanguage === 'en';

  const breadcrumbs = getBreadcrumbsPath(props);

  const isAllTemplates = activeCategory?.name === 'all';

  const hasActiveSubCategory = useMemo(
    () =>
      isEnabledMicroCategories
        ? Boolean(activeSubCategory || activeMicroCategorySlug || activeCategory) && !isAllTemplates
        : Boolean(activeSubCategory),
    [activeCategory, activeMicroCategorySlug, activeSubCategory, isAllTemplates, isEnabledMicroCategories],
  );

  return (
    <div className={cn(s.subHeader, !hasActiveSubCategory && s.subHeaderWithTopMargin)} data-hook={dataHook}>
      {hasActiveSubCategory && !isAllTemplates && (
        <SubHeaderBreadcrumbs dataHook={subHeaderDataHooks.breadcrumbs()} breadcrumbs={breadcrumbs} />
      )}
      <SubTitle dataHook={subHeaderDataHooks.subTitle()} />
      <SubText dataHook={subHeaderDataHooks.subText()} />
      <SubCategories dataHook={subHeaderDataHooks.subCategories()} />
    </div>
  );
};

export const SubHeader = injectStoresV2(
  'configStore',
  'routingStore',
  'templatesStore',
  'categoriesStore',
)(SubHeaderCmp);
